import clsx from 'clsx'
import { HTMLMotionProps, motion } from 'motion/react'
import { HTMLAttributes, ReactNode } from 'react'
import styles from './ListSection.module.css'

export interface ListSectionProps
	extends
		Omit<HTMLMotionProps<'section'>, 'title'>,
		Omit<HTMLAttributes<HTMLDivElement>, keyof HTMLMotionProps<'section'>> {
	title: ReactNode
	children?: ReactNode
}

export default function ListSection({ title, children, className, ...props }: ListSectionProps) {
	return (
		<motion.section className={clsx(styles.root, className)} {...props}>
			<h2 className={styles.title}>{title}</h2>
			<main>{children}</main>
		</motion.section>
	)
}
